export const PUBLIC_ROUTE = [
  '/login',
  '/register',
  '/reset-password',
  '/forget-password',
] as const;

export const PARTNERS = ['axiata'] as const;
